import { html } from 'rune-ts';
import klass from './FloatingButton.module.scss';
import { ProductListTypeS } from '../../../../../features/ProductList/outbound/share';
import { ProductThumbnail } from '../../ProductThumbnail/ProductThumbnail';
import { FloatingButtonBase } from './FloatingButtonBase';
import { makeFloatingButtonTemplate } from '../util';
import { DEFAULT_FLOATING_BUTTON_RECENT_PRODUCT_OPTION } from '../const';
import { type ProductCardData } from '../../../../../features/ProductList/type';
import { makeSubScreenNavigate } from '../../../../../shared/app/navigate';
import { dataStr } from '../../../../../shared/util/dataStr';

export type FloatingButtonRecentProductData = {
  product_thumbnail: {
    data: ProductListTypeS.ProductThumbnailData;
    option: ProductListTypeS.ProductThumbnailOption;
  };
  product_page_url: string;
};

export class FloatingButton_recent_product extends FloatingButtonBase<
  FloatingButtonRecentProductData & { show?: boolean }
> {
  static makeProps(
    data?: ProductCardData,
    option: ProductListTypeS.ProductThumbnailOption = DEFAULT_FLOATING_BUTTON_RECENT_PRODUCT_OPTION,
  ) {
    if (!data) return undefined;

    return {
      product_thumbnail: {
        data,
        option,
      },
      product_page_url: `/${data.domain_name}/products/${data.id}`,
    };
  }

  override template() {
    return makeFloatingButtonTemplate(
      html`<div class="${klass.floating_button}">
        <a
          href="${this.data.product_page_url}"
          data-post-message="${dataStr(makeSubScreenNavigate(this.data.product_page_url))}"
        >
          ${new ProductThumbnail(this.data.product_thumbnail.data, this.data.product_thumbnail.option)}
        </a>
      </div> `,
      this.state.show_itself,
    );
  }

  refresh(data: FloatingButtonRecentProductData) {
    this.data.product_thumbnail = data.product_thumbnail;
    this.data.product_page_url = data.product_page_url;
    this.redraw();
  }
}
